import hamburger from './modules/hamburger.js';
import fixedHeader from './modules/fixedHeader.js';

document.addEventListener('DOMContentLoaded', () => {
    hamburger();
    fixedHeader();
});

